import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ChargeHistoryModalComponent } from '../features/batch/pages/modal/charge-history-modal/charge-history-modal.component';

import { InputComponent } from './components/input/input.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { SearchableInputDropdownComponent } from './components/searchable-input-dropdown/searchable-input-dropdown.component';
import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { CalendarComponent } from './components/calendar/calendar.component';
import { TimePickerComponent } from './components/time-picker/time-picker.component';
import { TableComponent } from './components/table/table.component';
import { FilterComponent } from './components/filter/filter.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { ButtonComponent } from './components/button/button.component';
import { ContextMenuComponent } from './components/context-menu/context-menu.component';
import { BackButtonComponent } from './components/back-button/back-button.component';
import { ModalComponent } from './components/modal/modal.component';
import { ErrorNotificationComponent } from './components/error-notification/error-notification.component';
import { FormErrorMessageComponent } from './components/form-error-message/form-error-message.component';
import { DeleteConfirmationComponent } from './components/delete-confirmation/delete-confirmation.component';
import { PatientDocumentViewerComponent } from './components/patient-document-viewer/patient-document-viewer.component';
import { IconButtonComponent } from './components/icon-button/icon-button.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { PlanPopupComponent } from './components/plan-popup/plan-popup.component';
import { PatientPrintComponent } from './components/patient-print/patient-print.component';
import { PatientLabelPrintComponent } from './components/patient-label-print/patient-label-print.component';
import { AddressLabelPrintComponent } from './components/address-label-print/address-label-print.component';
import { ScrollToTopButtonComponent } from './components/scroll-to-top-button/scroll-to-top-button.component';
import { RbacCanDirective } from './directives/rbac-can.directive';
import { TableColumnResizeDirective } from './directives/table-column-resize.directive';
import { DelphiColorPipeModule } from './pipes/delphi-color-pipe.module';

@NgModule({
    declarations: [
        InputComponent,
        DropdownComponent,
        SearchableInputDropdownComponent,
        DatePickerComponent,
        CalendarComponent,
        TimePickerComponent,
        TableComponent,
        FilterComponent,
        PaginationComponent,
        SidebarComponent,
        ButtonComponent,
        ContextMenuComponent,
        ErrorNotificationComponent,
        BackButtonComponent,
        ModalComponent,
        FormErrorMessageComponent,
        DeleteConfirmationComponent,
        PatientDocumentViewerComponent,
        IconButtonComponent,
        PlanPopupComponent,
        PatientPrintComponent,
        PatientLabelPrintComponent,
        AddressLabelPrintComponent,
        ScrollToTopButtonComponent,
        ChargeHistoryModalComponent
    ],
    imports: [
        CommonModule,
        RbacCanDirective,
        TableColumnResizeDirective,
        ConfirmDialogComponent,
        DelphiColorPipeModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        FontAwesomeModule
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        FontAwesomeModule,
        InputComponent,
        DropdownComponent,
        SearchableInputDropdownComponent,
        DatePickerComponent,
        CalendarComponent,
        TimePickerComponent,
        TableComponent,
        FilterComponent,
        PaginationComponent,
        SidebarComponent,
        ButtonComponent,
        ContextMenuComponent,
        ErrorNotificationComponent,
        BackButtonComponent,
        ModalComponent,
        FormErrorMessageComponent,
        DeleteConfirmationComponent,
        PatientDocumentViewerComponent,
        IconButtonComponent,
        ConfirmDialogComponent,
        PlanPopupComponent,
        PatientPrintComponent,
        PatientLabelPrintComponent,
        AddressLabelPrintComponent,
        ScrollToTopButtonComponent,
        RbacCanDirective,
        TableColumnResizeDirective,
        ChargeHistoryModalComponent,
        DelphiColorPipeModule
    ]
})
export class SharedModule { }
